module.exports = __webpack_public_path__ + "static/x5b-eccdacd796811c497e4986a587b67f22.png";